import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./model.css";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

const VerifyModel = ({ show, onHide }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, [show]);

  // Handles navigation to the success page
  const handleLeaveClick = () => {
    navigate("/");
  };

  // Handles hiding the modal
  const handleStayClick = () => {
    onHide(); // Close the modal using the onHide callback
  };

  return (
    <>
      {loading ? (
        <Modal
          show={show}
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="verify-model"
        >
          <Modal.Body>
            <h4 className="m-0">
              <Skeleton
                height={21}
                className="custom-skeleton skelton-width-ctrl-one"
                style={{
                  borderRadius: "40px",
                  backgroundColor: "rgba(255, 255, 255, 0.20)",
                }}
              />
            </h4>
            <p className="m-0 py-4">
              <Skeleton
                count={1}
                height={14}
                width={319}
                className="custom-skeleton skelton-width-ctrl"
                style={{
                  borderRadius: "40px",
                  backgroundColor: "rgba(255, 255, 255, 0.10)",
                }}
              />
              <Skeleton
                count={1}
                height={14}
                className="custom-skeleton skelton-width-ctrl-one"
                width={242}
                style={{
                  borderRadius: "40px",
                  backgroundColor: "rgba(255, 255, 255, 0.10)",
                  marginTop: "24px",
                }}
              />
            </p>
            <div className="d-flex justify-content-center align-items-center pt-3 gap-3">
              {/* Button to leave and navigate */}
              <Button variant="">
                <Skeleton count={1} height={40} />
              </Button>

              {/* Button to stay on the page */}
              <Button variant="secondary">
                <Skeleton count={1} height={40} />
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <Modal
          show={show}
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="verify-model"
        >
          <Modal.Body>
            <h4 className="m-0">Точно хочете покинути сторінку?</h4>
            <p className="m-0 py-4">
              Якщо ви покинете сторінку, то всі внесенеі дані не будуть
              збережені.
            </p>
            <div className="d-flex justify-content-center align-items-center pt-3 gap-3">
              {/* Button to leave and navigate */}
              <Button variant="" onClick={handleLeaveClick}>
                Покинути
              </Button>

              {/* Button to stay on the page */}
              <Button variant="secondary" onClick={handleStayClick}>
                Залишитися
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default VerifyModel;
